import { SVGELEMENT } from '../../../../../enums/SVGELEMENT.js';
import EL from '../../../../EL/EL.js';
import { makeStruct } from '../../../../../enums/MODELS.js';
import { makeAttrStruct } from '../../../../../enums/ModelAttr.js';
import { makeDataStruct } from '../../../../../enums/ModelData.js';
// Model Structure
export const svgFilterAttr = makeAttrStruct([
    ['id'],
    ['x'],
    ['y']
]);
export const svgFilterData = makeDataStruct([]);
export const svgFilterModel = makeStruct([
    ['attributes', svgFilterAttr],
    ['data', svgFilterData]
]);
// Simplified Model
export function svgFilter(id, x, y) {
    return {
        attributes: svgFilterAttr(id, x, y),
        data: svgFilterData()
    };
}
/** Creates a Filter within an SVG Def */
export default class SVGFILTER extends EL {
    constructor(node, model) {
        super(node, SVGELEMENT.FILTER, model);
    }
    /** Creates the DOM HTMLElement during instantiation
     * Override this method to create a custom element
     */
    createElement() {
        const el = document.createElementNS('http://www.w3.org/2000/svg', this.element);
        return el;
    }
}
export { EL };
